var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column account-info"},[_c('Counters'),_c('Socials',{staticClass:"mb-5"}),_c('Streams',{staticClass:"mb-5"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }